let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6L998")).then(() => parcelRequire('khTCh'));